/* Carrusel coverflow infinito: la tarjeta activa siempre en el centro, bucle sin fin. */
(function () {
  if (customElements.get('infinite-coverflow')) return;

  class InfiniteCoverflow extends HTMLElement {
    connectedCallback() {
      this._tries = 0;
      this._init();
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    _init() {
      this.stage = this.querySelector('[data-stage]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-card]'));
      if (!this.stage || this.cards.length === 0) {
        if (this._tries++ < 90) requestAnimationFrame(this._init.bind(this));
        return;
      }
      if (this._ready) return;
      this._ready = true;

      this.n = this.cards.length;
      this.active = 0;
      var self = this;

      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.go(-1); });
      if (next) next.addEventListener('click', function () { self.go(1); });

      this.cards.forEach(function (card, i) {
        card.addEventListener('click', function (e) {
          if (i !== self.active) { e.preventDefault(); self.goTo(i); }
        });
      });

      // Swipe táctil
      var startX = null;
      this.stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      this.stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) self.go(dx < 0 ? 1 : -1);
        startX = null;
      }, { passive: true });

      this._onResize = function () { self.layout(); };
      window.addEventListener('resize', this._onResize);

      // Recalcular cuando carguen las imágenes (cambia la altura)
      this.cards.forEach(function (card) {
        var img = card.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', function () { self.layout(); }, { once: true });
      });

      this.layout();
    }

    metrics() {
      var w = this.stage.clientWidth || this.clientWidth;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var cardW = w * (isMobile ? parseFloat(this.dataset.cardMobile || 0.72) : parseFloat(this.dataset.cardDesktop || 0.42));
      // En escritorio se limita el ancho a un valor en REM. Un ancho proporcional al
      // viewport NO cambia de tamaño físico al hacer zoom (el zoom encoge el viewport
      // en la misma proporción); un ancho en rem SÍ escala con el zoom. Así el carrusel
      // de la home crece/encoge con el zoom como el resto de la web. Editable con el
      // atributo data-card-max-rem-desktop (por defecto 42rem).
      if (!isMobile) {
        var rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
        var maxRem = parseFloat(this.dataset.cardMaxRemDesktop || 34);
        cardW = Math.min(cardW, maxRem * rootPx);
      }
      var step = cardW * (isMobile ? parseFloat(this.dataset.stepMobile || 0.94) : parseFloat(this.dataset.stepDesktop || 0.72));
      var maxVisible = isMobile ? 1 : 2;
      return { cardW: cardW, step: step, maxVisible: maxVisible };
    }

    layout() {
      var m = this.metrics();
      this.cards.forEach(function (card) { card.style.width = m.cardW + 'px'; });
      var maxH = 0;
      this.cards.forEach(function (card) { if (card.offsetHeight > maxH) maxH = card.offsetHeight; });
      this.stage.style.height = maxH + 'px';
      // Centrar las flechas sobre la imagen (misma altura en todos los carruseles)
      var img = this.cards[0] && this.cards[0].querySelector('img');
      var imgH = img ? img.offsetHeight : 0;
      if (imgH) {
        var arrows = this.querySelectorAll('[data-prev], [data-next]');
        for (var k = 0; k < arrows.length; k++) { arrows[k].style.top = (imgH / 2) + 'px'; }
      }
      this.render();
    }

    render() {
      var m = this.metrics();
      var n = this.n;
      var active = this.active;
      var useDim = this.dataset.fade === 'dim';
      this.cards.forEach(function (card, i) {
        var diff = i - active;
        if (diff > n / 2) diff -= n;
        if (diff < -n / 2) diff += n;
        var absd = Math.abs(diff);
        var visible = absd <= m.maxVisible;
        var scale = diff === 0 ? 1 : 0.84;
        // Wrap del carrusel infinito: si la card "salta" al otro lado, teletransporta
        // su posición (solo se anima el fundido, no el deslizamiento) para que las
        // laterales NO crucen la pantalla "en círculo" — desaparecen hacia su lado y ya.
        var prevDiff = card._cfDiff;
        card._cfDiff = diff;
        card.style.transition =
          prevDiff !== undefined && Math.abs(diff - prevDiff) > 1 ? 'opacity 0.5s ease' : '';
        card.style.transform = 'translateX(' + (diff * m.step) + 'px) translateX(-50%) scale(' + scale + ')';
        card.style.zIndex = String(20 - absd);
        if (!visible) {
          card.style.opacity = '0';
          card.style.filter = '';
        } else if (diff === 0) {
          card.style.opacity = '1';
          card.style.filter = '';
        } else {
          // Laterales. Con data-fade="dim" quedan OPACAS (opacity 1) y el atenuado
          // "lavado" se hace con un velo claro por CSS (::after), no con transparencia,
          // para que se vean igual que productos pero SIN ver cards a través.
          card.style.opacity = useDim ? '1' : '0.75';
          card.style.filter = '';
        }
        card.style.pointerEvents = visible ? 'auto' : 'none';
        card.classList.toggle('is-active', diff === 0);
      });
    }

    go(dir) {
      this.active = (this.active + dir + this.n) % this.n;
      this.render();
    }

    goTo(i) {
      this.active = ((i % this.n) + this.n) % this.n;
      this.render();
    }
  }

  customElements.define('infinite-coverflow', InfiniteCoverflow);
})();
